import React from "react";
import { useLookup } from "@redriver/cinnamon";
import { useSelector } from "react-redux";
import moment from "moment";
import { getRepFormData } from "./selectors";
import { Message } from "semantic-ui-react";
import { genderLookup, uniformSizesLookup } from "./lookups";

const PassengerSummaryMessage = () => {
  const formData = useSelector(getRepFormData);

  const [{ response: genderResponse }] = useLookup(genderLookup);
  const [{ response: uniformResponse }] = useLookup(uniformSizesLookup);

  const summaryItems = [
    {
      name: "Personal",
      items: [
        {
          name: "Title",
          value: formData.personal.title,
        },
        {
          name: "First Name",
          value: formData.personal.firstName,
        },
        {
          name: "Middle Name",
          value: formData.personal.middleName,
        },
        {
          name: "Last Name",
          value: formData.personal.lastName,
        },
        {
          name: "Gender",
          value: (genderResponse || []).find(
            (x) => x.value == formData.personal.gender
          )?.text,
        },
      ],
    },
    {
      name: "Passport",
      items: [
        {
          name: "Passport Number",
          value: formData.passport.passportNum,
        },
        {
          name: "Passport Date of Issue",
          value: moment(formData.passport.passportDateOfIssue).format(
            "DD/MM/YYYY"
          ),
        },
        {
          name: "Passport Expiry Date",
          value: moment(formData.passport.passportExpiryDate).format(
            "DD/MM/YYYY"
          ),
        },
        {
          name: "Nationality",
          value: formData.passport.nationalityId
            ? formData.passport.nationality
            : "",
        },
        {
          name: "Country of Issue/Code",
          value: formData.passport.issueCountryId
            ? formData.passport.issueCountry
            : "",
        },
      ],
    },
    {
      name: "Medical and Dietary",
      items: [
        {
          name: "Do you have medical/dietary requirements?",
          value: formData.medical.hasMedicalRequirements ? "Yes" : "No",
        },
        {
          name: "Dietary Requirements",
          value: formData.medical.dietaryRequirements,
          hidden: !formData.medical.hasMedicalRequirements,
        },
        {
          name: "Epipen Carrier",
          value: formData.medical.epipenCarrier ? "Yes" : "No",
          hidden: !formData.medical.hasMedicalRequirements,
        },
        {
          name: "Medical Requirements",
          value: formData.medical.medicalRequirements,
          hidden: !formData.medical.hasMedicalRequirements,
        },
      ],
    },
    {
      name: "Additional Details",
      items: [
        {
          name: "Next of Kin",
          value: formData.additional?.nextOfKin,
        },
        {
          name: "Next of Kin Contact Number",
          value: formData.additional?.nextOfKinContact,
        },
        {
          name: "Next of Kin Relationship",
          value: formData.additional?.nextOfKinRelationship,
        },

        {
          name: "Driving Licence",
          value: formData.additional?.drivingLicence ? "Yes" : "No",
        },
        {
          name: "Additional Information",
          value: (uniformResponse || []).find(
            (x) => x.value == formData.additional?.uniformSize
          )?.text,
        },
      ],
    },
  ];

  return (
    <Message positive>
      <Message.Header>Summary of Submitted Information</Message.Header>
      <Message.Content>
        {summaryItems
          .filter((x) => x.hidden != true)
          .map((s, i) => {
            return (
              <p key={i}>
                <b>{s.name}</b>
                <br />
                {s.items
                  .filter((x) => x.hidden != true)
                  .map((x, i) => {
                    return (
                      <span key={i} style={{ display: "block" }}>{`${x.name}: ${
                        (typeof x.value == "function" ? x.value() : x.value) ||
                        ""
                      }`}</span>
                    );
                  })}
              </p>
            );
          })}
      </Message.Content>
    </Message>
  );
};

export default PassengerSummaryMessage;
